/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/


export enum PncTabsEnum {
    ALL = 'ALL',
    TODO = 'TODO',
    MY_LIST = 'MY_LIST'
}

